import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";
import { injectAutomationHeaderResponsiveStyles } from "./responsive-styles";

injectAutomationHeaderResponsiveStyles();

export const StyledAutomationHeader = styled.div.attrs({
  className: "au-automation-header",
})`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
`;

export const StyledAutomationHeaderBody = styled.div.attrs({
  className: "au-automation-header-body",
})`
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
`;

export const StyledAutomationHeaderText = styled.div.attrs({
  className: "au-automation-header-text",
})`
  flex: 1 1 0%;
  min-width: 0;
`;

export const StyledAutomationHeaderTitle = styled.div`
  font-size: 18px;
  line-height: 25px;
  font-family: inherit;
  color: ${TextColorNames.primary};
`;

export const StyledAutomationHeaderActions = styled.div.attrs({
  className: "au-automation-header-actions",
})`
  display: flex;
  flex: 0 0 auto;
  align-self: flex-start;
  align-items: center;
  gap: 10px;
`;
